import dayjs from "dayjs";
import { ReviewChapter, ReviewRun } from "../../types/reviewTypes";
import { Book } from "../../types/material";

export interface VerseStats {
  b: number;
  c: number;
  v: number;
  incorrect: number;
  correct: number;
  time: number;
}
export interface TotalVerseCardsStats {
  totalVerses: number;
  correct: number;
  incorrect: number;
  time: number;

  // Numbers that don't include review
  absCorrect: number;
  absIncorrect: number;
  absTime: number;
}

export const verseCardsStateKey = "verse-cards-state";

export const constructReviewRun = (
  material: Book[],
  verses: VerseStats[],
  id: string,
  time?: string
) => {
  // Compile run structure
  const newRun: ReviewRun = {
    runId: id,
    totalVerses: 0,
    percent: 0,
    averageTime: 0,
    runTime: time || dayjs().format(),
    results: [],
  };
  const allChapters: Record<string, ReviewChapter> = {};
  verses.forEach((verse) => {
    const key = `${verse.b}-${verse.c}`;
    if (!allChapters[key]) {
      allChapters[key] = {
        book: verse.b,
        chapter: verse.c,
        correct: [],
        incorrect: [],
        time: 0,
      };
    }
    if (verse.incorrect >= 1) {
      allChapters[key].incorrect.push(verse.v);
    } else {
      allChapters[key].correct?.push(verse.v);
    }
    allChapters[key].time += verse.time;
  });
  newRun.results = Object.values(allChapters);
  newRun.results.forEach((chapter) => {
    // Possibly prune correct array
    if (
      material[chapter.book].chapters[chapter.chapter].length ===
      (chapter.correct?.length || 0) + chapter.incorrect.length
    ) {
      delete chapter.correct;
    }
  });

  return newRun;
};
